export default {
  'breakManagement.title': '休息 & 加班',
  'breakManagement.tabs.break': '休息',
  'breakManagement.tabs.overtime': '加班',
  'breakManagement.convertExceedPaidBreakToUnpaid': '将带薪休息的超时时间转换为无薪休息',
  'breakManagement.enforceFullTimeUnpaidBreak': '强制执行无薪休息，在无薪休息结束前不能再次打卡',
  'breakManagement.recordOvertime': '记录加班时间并显示在员工报表上',
  'breakManagement.overtimeThreshold': '日加班时长: 超过输入小时数的时长将被计为加班时长。',
  'breakManagement.overtimeThreshold.unit': '小时',
  'breakManagement.breaks.notice': '如果餐厅没有设置休息类型，休息时长将被计为无薪。',

  'breakManagement.column.name': '英文名',
  'breakManagement.column.foreign_name': '中文名',
  'breakManagement.column.display_name': '名称',
  'breakManagement.column.type': '类型',
  'breakManagement.column.duration': '时长 (分钟)',
  'breakManagement.column.active': '是否开启',
  'breakManagement.column.action': '操作',

  'breakManagement.create.title': '新建休息',
  'breakManagement.edit.title': '编辑休息',

  'breakManagement.action.create': '新建休息',
  'breakManagement.confirmation.deletion': '确认要删除此项配置吗？',

  'breakManagement.overtime.overtimeRules': `加班规则 <span class="helperText">（为确保数据准确，强烈建议在当前工作周结束后至下一个工作周开始前修改加班规则）</span>`,
  'breakManagement.overtime.add.overtimeRules': '新增加班规则',
  'breakManagement.overtime.edit.overtimeRules': '编辑加班规则',

  'breakManagement.overtime.dailyHours': '每日工作',
  'breakManagement.overtime.weeklyHours': '每周工作',
  'breakManagement.overtime.consecutive_days': '连续工作',
  'breakManagement.overtime.consecutive_days_tips': '指在一个工作周内连续数天工作没有休息日',

  'breakManagement.overtime.daily.overtimeRules': '每日加班规则',
  'breakManagement.overtime.weekly.overtimeRules': '每周加班规则',
  'breakManagement.overtime.consecutive_days.overtimeRules': '连续工作加班规则',

  'breakManagement.overtime.workHoursExceed': '工作时间超过',
  'breakManagement.overtime.overtimeRateFactor': '加班费系数',

  'breakManagement.overtime.pleaseSetAtLeastOneCompleteRule': '请至少设置一个完整的规则',
  'breakManagement.overtime.pleaseSetCompleteRule': '请输入完整的规则',
  'breakManagement.overtime.hourlyRuleAlreadyExist': '时长规则已存在',

  'breakManagement.overtime.type.daily': '每日工作时间',
  'breakManagement.overtime.type.weekly': '每周工作时间',
  'breakManagement.overtime.type.consecutive_days': '连续工作',

  'breakManagement.overtime.column.workHoursExceedAndOvertimeRateFactor':
    '工作时间超过 {hours} 小时, 加班费系数 {rate}',
  'breakManagement.overtime.column.consecutive_days': '连续上班 {days} 天',
  'breakManagement.overtime.column.rules': '规则',

  'breakManagement.overtime.column.overtimeHours': '{rate}x',
  'breakManagement.overtime.column.clockOutTips': '请检查并确认异常记录',
};
